import { History } from 'history'
import { LiveFunctionCall } from '../GeminiLiveAPI/lib/multimodal-live-types'

interface DisplayMessageArgs {
  message: string
}

export const TOOL_NAME = 'preview_submit_site_visit'

export function PreviewSubmitSiteVisitToolCall(functionCall: LiveFunctionCall, history: History) {
  const args = functionCall.args as DisplayMessageArgs

  const fields = [
    { key: 'project_id', label: 'Project ID' },
    { key: 'site_notes', label: 'Site Notes' },
    { key: 'roof_type', label: 'Roof Type' },
    { key: 'number_of_storeys', label: 'Number of Storeys' },
    { key: 'number_of_phases', label: 'Number of Phases' },
    { key: 'number_of_wires', label: 'Number of Wires' },
    { key: 'meter_identifier', label: 'Meter Identifier' },
    { key: 'parcel_identifier', label: 'Parcel Identifier' },
    { key: 'has_cellular_coverage', label: 'Has Cellular Coverage' },
    { key: 'wind_region', label: 'Wind Region' },
    { key: 'power_factor', label: 'Power Factor' },
  ]

  let message = 'Site Visit Fields:'
  fields.forEach((field) => {
    message += `\n - ${field.label}: ${args[field.key] ? args[field.key] + ' ✅' : '❓'}`
  })

  return {
    success: true,
    message: message,
  }
}
